<template>
  <div class="home">
    <div class="header">
      <div
        class="
          primary
          d-none d-sm-none d-md-block d-lg-block d-xl-block
          top-bar
        "
      >
        <v-container class="py-0">
          <v-row align="center" justify="space-between" no-gutters>
            <v-col cols="auto" class="d-flex align-center">
              <v-btn
                color="secondary"
                class="home-topbar-btn"
                outlined
                small
                @click="priceListOpen"
              >
                <v-icon left small>mdi-download</v-icon>
                Download Price List
              </v-btn>
            </v-col>

            <v-col cols="auto" class="d-flex align-center">
              <v-btn
                class="home-topbar-btn"
                color="secondary"
                outlined
                small
                href="retail-payment-confirm"
              >
                <v-icon left small>mdi-credit-card-check-outline</v-icon>
                Payment Confirmation
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <v-app-bar
        color="secondary"
        dark
        fixed
        flat
        height="125px"
        class="mt-md-8 mt-lg-8 home-app-bar"
      >
        <v-container>
          <v-row align="center" id="container" ref="container" class="py-2">
            <v-col
              cols="12"
              md="3"
              lg="3"
              class="
                d-none d-sm-none d-md-flex d-lg-flex d-xl-flex
                justify-center
              "
            >
              <img
                alt="Vue logo"
                src="../assets/logo.png"
                height="100"
                contain
                class="home-logo"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="6"
              class="d-none d-sm-none d-md-block d-lg-block d-xl-block"
            >
              <div class="d-flex align-center">
                <div class="d-flex align-center flex-wrap">
                  <div v-for="(menu, index) in menus" :key="index">
                    <v-btn
                      small
                      text
                      color="white"
                      class="mr-2 my-1"
                      :href="menu.href"
                      >{{ menu.text }}</v-btn
                    >
                  </div>
                </div>
                <div class="text-center ml-2">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        v-bind="attrs"
                        v-on="on"
                        small
                        depressed
                        class="secondary--text font-weight-medium"
                      >
                        Blog
                      </v-btn>
                    </template>
                    <v-list>
                      <div v-for="item in getBlogList" :key="item.id">
                        <v-list-item :href="`/blog/${item.id}`">
                          <v-list-item-title>{{
                            item.title
                          }}</v-list-item-title>
                        </v-list-item>
                      </div>
                    </v-list>
                  </v-menu>
                </div>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="
                d-flex d-sm-flex d-md-none d-lg-none d-xl-none
                align-center
                justify-space-between
              "
            >
              <div class="d-flex align-center">
                <img
                  alt="Vue logo"
                  src="../assets/logo.png"
                  height="56"
                  contain
                />
              </div>
              <div class="d-flex align-center">
                <v-btn
                  icon
                  v-if="cartQty"
                  @click="popupCheckout"
                  aria-label="Open cart"
                >
                  <v-badge
                    color="black"
                    :content="cartQty"
                    overlap
                    offset-x="10"
                    offset-y="10"
                  >
                    <v-icon color="white">mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
                <v-btn icon v-else aria-label="Open cart">
                  <v-badge
                    color="black"
                    content="0"
                    overlap
                    offset-x="10"
                    offset-y="10"
                    bordered
                  >
                    <v-icon color="white">mdi-cart-outline</v-icon>
                  </v-badge>
                </v-btn>
                <v-app-bar-nav-icon
                  @click.stop="drawer = !drawer"
                ></v-app-bar-nav-icon>
              </div>
            </v-col>

            <v-col
              cols="12"
              md="3"
              lg="3"
              class="
                d-none d-sm-none d-md-flex d-lg-flex d-xl-flex
                justify-end
                align-center
              "
            >
              <v-btn
                icon
                v-if="cartQty"
                class="mr-2"
                @click="popupCheckout"
                aria-label="Open cart"
              >
                <v-badge
                  color="black"
                  :content="cartQty"
                  overlap
                  offset-x="10"
                  offset-y="10"
                >
                  <v-icon color="white">mdi-cart-outline</v-icon>
                </v-badge>
              </v-btn>
              <v-btn icon v-else class="mr-2" aria-label="Open cart">
                <v-badge
                  color="black"
                  content="0"
                  overlap
                  offset-x="10"
                  offset-y="10"
                  bordered
                >
                  <v-icon color="white">mdi-cart-outline</v-icon>
                </v-badge>
              </v-btn>
              <div class="d-flex align-center mr-3">
                <span class="text-caption mr-2 d-none d-lg-inline white--text"
                  >NET TOTAL</span
                >
                <span class="font-weight-medium primary--text"
                  >₹ {{ productSalesPrice }}</span
                >
              </div>
              <v-btn outlined color="primary" @click="contactDialog = true">
                <v-icon color="primary" small class="mr-2">mdi-phone</v-icon>
                Contact
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
        <v-btn
          fab
          tile
          color="secondary"
          bottom
          right
          absolute
          v-if="cartQty"
          class="mr-n4 mb-n15 rounded-lg rounded-r-0"
          height="45"
          @click="popupCheckout"
        >
          <v-badge
            color="black"
            left
            :content="cartQty"
            overlap
            offset-x="0"
            offset-y="0"
          >
            <v-icon color="white" size="30">mdi-cart-variant</v-icon>
          </v-badge>
        </v-btn>

        <v-btn
          fab
          tile
          color="secondary"
          bottom
          right
          absolute
          v-if="cartQty == ''"
          class="mr-n4 mb-n15 rounded-lg rounded-r-0"
          height="45"
        >
          <v-badge
            color="black"
            left
            content="0"
            overlap
            offset-x="0"
            offset-y="0"
          >
            <v-icon color="white" size="30">mdi-cart-variant</v-icon>
          </v-badge>
        </v-btn>
      </v-app-bar>

      <v-dialog v-model="contactDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Contact Details
          </v-card-title>

          <v-card-text>
            <p class="mb-1 mt-5">
              <v-icon color="primary" small>mdi-phone</v-icon> Sivakasi : 8248404493, 7904103838
            </p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="contactDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!--Navigation Drawer-->
      <v-navigation-drawer v-model="drawer" absolute right temporary>
        <v-list nav dense>
          <v-list-item-group v-model="group" active-class="primary white--text">
            <div v-for="item in menus" :key="item.text">
              <v-list-item :href="item.href">
                <v-list-item-title>{{ item.text }}</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
            </div>
            <div v-for="item in getBlogList" :key="item.id">
              <v-list-item :href="`/blog/${item.id}`">
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
            </div>
          </v-list-item-group>
        </v-list>
      </v-navigation-drawer>
      <!--Navigation Drawer-->
    </div>
    <v-container>
      <div class="productdiv" ref="productdiv1"></div>
      <v-card class="mt-1 mx-auto" height="150" elevation="0">
        <div
          class="
            d-flex
            flex-column
            fill-height
            justify-center
            align-center
            text-black
          "
        >
          <h1 class="primary--text">
            {{ banner.title }}
          </h1>
        </div>
      </v-card>

      <v-card class="mx-auto" elevation="0">
        <div
          class="
            d-flex
            flex-column
            fill-height
            justify-center
            align-center
            text-black
          "
        >
          <div v-html="banner.details" class="text-justify"></div>
        </div>
      </v-card>
    </v-container>

    <loading v-if="loading" />

    <!--footer Component-->
    <div>
      <footerCommon />
    </div>

    <!--footer Component-->
  </div>
</template>

<style scoped>
.home-app-bar {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.home-logo {
  display: block;
  max-width: 100%;
}

.home-topbar-btn {
  margin: 8px 0;
  text-transform: none;
}

.top-bar {
  position: fixed;
  width: 100%;
  z-index: 111;
  min-height: 48px;
  display: flex;
  align-items: center;
}

.v-application p {
  margin-bottom: 0px;
}
.productdiv {
  margin-top: 165px !important;
}

.banner-text {
  line-height: 50px;
}

.product-cart-div {
  width: 100%;
  display: block;
  margin: 0 auto;
}

.product-cart-card {
  width: 100%;
  display: block;
  margin: 0 auto;
  margin-bottom: 10px;
}

.v-navigation-drawer {
  position: fixed !important;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { VUE_WEB_BASEURL } from "../utils/api";

export default {
  name: "TermsAndCondition",
  data: () => ({
    productRate: "0.00",
    productOfferPrice: "0.00",
    productSalesPrice: "0.00",
    contactDialog: false,
    cartQty: 0,
    menus: [
      {
        text: "Home",
        disabled: false,
        href: "/home",
      },
      {
        text: "Retail Price",
        disabled: false,
        href: "/",
      },
      // {
      //   text: "Family pack",
      //   disabled: false,
      //   href: "familypack",
      // },
      // {
      //   text: "Wholesale case",
      //   disabled: false,
      //   href: "wholesale",
      // },
      // {
      //   text: "Whole sale",
      //   disabled: false,
      //   href: "diwali",
      // },
      // {
      //   text: "Gift box",
      //   disabled: false,
      //   href: "giftbox",
      // },
      {
        text: "About Us",
        disabled: false,
        href: "/aboutus",
      },
      {
        text: "Contact Us",
        disabled: false,
        href: "/contact-us",
      },
    ],
    drawer: false,
    group: null,
  }),
  computed: {
    ...mapGetters([
      "authStatus",
      "authStatusError",
      "authStatusresponse",
      "getBannerDetails",
      "getBlogList",
    ]),

    loading: function () {
      return this.authStatus === "loading";
    },
    banner: function () {
      return this.getBannerDetails;
    },
  },
  created() {
    this.fetchPageDetails("10");
    this.fetchBlog();
  },
  methods: {
    ...mapActions(["fetchPageDetails", "fetchBlog"]),
    priceListOpen() {
      window.open(VUE_WEB_BASEURL + "retail-product/", "_blank");
    },
    popupCheckout() {},
  },
};
</script>
